// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterOption } from '@/components/filter-toggle-group';
import {
  ListOutlined,
  TrendingUpOutlined,
} from '@/constants/hardfin-standard-icons';
import { TrackingViewMode } from '@/report/types';

export const COST_VIEW_MODE_OPTIONS: FilterOption<TrackingViewMode>[] = [
  { value: 'table', label: 'Table', icon: <ListOutlined fontSize="small" /> },
  {
    value: 'analytics',
    label: 'Analytics',
    icon: <TrendingUpOutlined fontSize="small" />,
  },
];
